import LockupAddToCartButton from './lockupAddToCartButton'

export default LockupAddToCartButton
